<template>
    <span>
        <span class="yellow" v-if="this.status === 'NUOVO'">
            <b><i>{{$t('prenotazione_nuova')}}</i></b>
        </span>
        <span class="yellow" v-else-if="this.status === 'ATTESA'">
            <b><i>{{$t('prenotazione_attesa')}}</i></b>
        </span>
        <span class="red" v-else-if="this.status === 'ANNULLATO'">
            <b><i>{{$t('prenotazione_annullata')}}</i></b>
        </span>
        <span class="red" v-else-if="this.status === 'RIFIUTATO'">
            <b><i>{{$t('prenotazione_rifiutata')}}</i></b>
        </span>
        <span class="green" v-else-if="this.status === 'CONFERMATO'">
            <b><i>{{$t('prenotazione_confermata')}}</i></b>
        </span>
    </span>
</template>

<script>
    export default {
        name: "IncReservationStatus",
        props: ['status']
    }
</script>
